import { useMemo } from "react";
import { ProductDetailHeadingModel, ProductDetailHeadingProps } from "./ProductDetailHeading.componentModel";

export const useComponentData = (props: ProductDetailHeadingProps) => {
  const componentData = useMemo(() => new ProductDetailHeadingModel({ props }), [props]);

  return { componentData };
};
